var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9961 13.6676H25.6628C28.3294 13.6676 29.6628 12.3343 29.6628 9.66764V7.00098C29.6628 4.33431 28.3294 3.00098 25.6628 3.00098H22.9961C20.3294 3.00098 18.9961 4.33431 18.9961 7.00098V9.66764C18.9961 12.3343 20.3294 13.6676 22.9961 13.6676Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99609 29.6676H9.66276C12.3294 29.6676 13.6628 28.3343 13.6628 25.6676V23.001C13.6628 20.3343 12.3294 19.001 9.66276 19.001H6.99609C4.32943 19.001 2.99609 20.3343 2.99609 23.001V25.6676C2.99609 28.3343 4.32943 29.6676 6.99609 29.6676Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32943 13.6676C11.2749 13.6676 13.6628 11.2798 13.6628 8.33431C13.6628 5.38879 11.2749 3.00098 8.32943 3.00098C5.38391 3.00098 2.99609 5.38879 2.99609 8.33431C2.99609 11.2798 5.38391 13.6676 8.32943 13.6676Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3294 29.6676C27.2749 29.6676 29.6628 27.2798 29.6628 24.3343C29.6628 21.3888 27.2749 19.001 24.3294 19.001C21.3839 19.001 18.9961 21.3888 18.9961 24.3343C18.9961 27.2798 21.3839 29.6676 24.3294 29.6676Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.743a0cd048cadf27f33bbd48e55dbe7e.svg";
export { ForwardRef as ReactComponent };